import { render } from "./FeedbackDetailView.vue?vue&type=template&id=7e5d0ef7&scoped=true"
import script from "./FeedbackDetailView.vue?vue&type=script&lang=js"
export * from "./FeedbackDetailView.vue?vue&type=script&lang=js"

import "./FeedbackDetailView.vue?vue&type=style&index=0&id=7e5d0ef7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5d0ef7"]])

export default __exports__